const jQ = jQuery.noConflict();

const initScroll = () => {
	const link = window.location.href;
	const id = link.substr(link.lastIndexOf('/') + 1);
	const char = '#';

	if (id.includes(char)) {
		const headerHeight = window.innerWidth > 768 ? 105 : 55;
		const targetOffsetTop = jQ(id).offset().top - headerHeight;

		jQ('html, body').scrollTop(targetOffsetTop);
	}
};

export default initScroll;



// WEBPACK FOOTER //
// ./app/themes/nordic-concert-halls/js/utils/initScroll.js